import {
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

async function preparePolyfills(): Promise<void> {
  // Barcode Detection API polyfill (ZXing WASM) for web scanning in browsers
  // without native BarcodeDetector (Safari, Firefox). Loaded ONLY on web and
  // only when the API is missing — native apps scan via ML Kit and never
  // need it. Must complete before bootstrap: the ML Kit plugin's web
  // implementation checks `'BarcodeDetector' in window` once at construction.
  if (!Capacitor.isNativePlatform() && !('BarcodeDetector' in window)) {
    await import('barcode-detector/polyfill');
  }
}

preparePolyfills()
  .catch((err) => console.log('barcode polyfill load failed', err))
  .then(() =>
    bootstrapApplication(AppComponent, {
      providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(
          BrowserModule,
          IonicModule.forRoot(),
          AppRoutingModule,
          IonicStorageModule.forRoot()
        ),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      ],
    })
  )
  .catch((err) => console.log(err));
